/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Defaulttriage_Description1Inputs */

const en_cases_settings_defaulttriage_description1 = /** @type {(inputs: Cases_Settings_Defaulttriage_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applies to cases that have not yet been classified into a category.`)
};

/**
* | output |
* | --- |
* | "Applies to cases that have not yet been classified into a category." |
*
* @param {Cases_Settings_Defaulttriage_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_defaulttriage_description1 = /** @type {((inputs?: Cases_Settings_Defaulttriage_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Defaulttriage_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_defaulttriage_description1(inputs)
});
export { cases_settings_defaulttriage_description1 as "cases_settings_defaultTriage_description" }